import { useState } from "react";

export default function TableGridPicker({ onPick, onClose }) {
  const [hover, setHover] = useState({ r: 0, c: 0 });
  const SIZE = 8;
  return (
    <div
      style={{
        position: "absolute", top: "100%", left: 0, zIndex: 1500,
        padding: 10, background: "#fff", border: "1px solid #e2e8f0",
        borderRadius: 10, boxShadow: "0 12px 32px rgba(15,23,42,0.12)",
      }}
      onMouseLeave={() => setHover({ r: 0, c: 0 })}
    >
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${SIZE}, 16px)`, gap: 2 }}>
        {Array.from({ length: SIZE * SIZE }).map((_, i) => {
          const r = Math.floor(i / SIZE) + 1;
          const c = (i % SIZE) + 1;
          const active = r <= hover.r && c <= hover.c;
          return (
            <div
              key={i}
              style={{
                width: 16, height: 16, borderRadius: 3,
                border: "1px solid #cbd5e1",
                background: active ? "#6366f1" : "#f8fafc",
                cursor: "pointer",
              }}
              onMouseEnter={() => setHover({ r, c })}
              onClick={() => { onPick(r, c); onClose(); }}
            />
          );
        })}
      </div>
      <div style={{ fontSize: 11, color: "#64748b", marginTop: 6, textAlign: "center" }}>
        {hover.r > 0 ? `${hover.r} × ${hover.c}` : "Hover to pick size"}
      </div>
    </div>
  );
}
